var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 7H0.0625C0.0626265 5.55972 0.511017 4.15519 1.34546 2.98127C2.17991 1.80735 3.35903 0.922234 4.71925 0.448734C6.07947 -0.0247667 7.55334 -0.0631786 8.93637 0.338827C10.3194 0.740833 11.543 1.56332 12.4375 2.69219V1.65625H13.375V4.9375H10.0938V4H12.1959C11.6688 3.08836 10.9113 2.33132 9.99937 1.80478C9.08741 1.27824 8.05305 1.0007 7 1C3.69156 1 1 3.69156 1 7ZM13 7C13 10.3084 10.3084 13 7 13C5.94695 12.9993 4.91259 12.7218 4.00063 12.1952C3.08867 11.6687 2.33116 10.9116 1.80406 10H3.90625V9.0625H0.625V12.3438H1.5625V11.3078C2.45696 12.4367 3.68059 13.2592 5.06363 13.6612C6.44666 14.0632 7.92053 14.0248 9.28075 13.5513C10.641 13.0778 11.8201 12.1927 12.6545 11.0187C13.489 9.84481 13.9374 8.44028 13.9375 7H13Z",
    fill: "#15274B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResend);
export default __webpack_public_path__ + "static/media/resend.94da88e9e0bf49547274002d99c750d1.svg";
export { ForwardRef as ReactComponent };